export enum SettingsIntegrationTabs {
  settings = "settings",
  employees = "employees",
}
